import React from 'react'

const Interestoptimisation = ({ data, pageJson, translateWordForOption, translations, poolingStructurePageJson, accountCountryList, getProductRelatedTaxonomy }) => (

  <div className="detail-container m-t-30">
    <div className="detail-container__heading">{`5. ${translations(pageJson.pageHeading)}`}</div>
    <div className="detail-container__content clearfix">
      <div className="detail-container__horizontal-row">
        {data.notionalPooling !== undefined && data.notionalPooling.interestOptimisations !== undefined && data.notionalPooling.interestOptimisations !== null && data.notionalPooling.interestOptimisations.length !== 0 ?
          <dl class="ie-detail-section__content__list">
            <dt>{translations(pageJson.InterestOptimisationReq)}</dt>
            <dd>{data.notionalPooling.isIERequired === true ? 'Yes' : (data.notionalPooling.isIERequired === false ? 'No' : 'None')}</dd>
          </dl> : ''}
        {

          data !== undefined && data.notionalPooling !== undefined && data.notionalPooling !== null && data.notionalPooling.isIERequired === true && data.notionalPooling.interestOptimisations !== undefined && data.notionalPooling.interestOptimisations !== null && Object.keys(data.notionalPooling.interestOptimisations).length !== 0 ?
            data.notionalPooling.interestOptimisations.map((item, key) => {
              return [
                <div>
                  {
                    data.otherAccounts.map(ele => {
                      if (ele.id === item.id) {
                        return <dl><dt>{translations(pageJson.standaloneAccount)}</dt><dd>{ele.accountNumber}, {ele.branchCode}, {accountCountryList ? getProductRelatedTaxonomy(ele).country.name : ele.country.name}, {ele.currency.name} <br /> {ele.accountHolder.name}</dd></dl>
                      }
                    })
                  }
                  {
                    data.notionalPooling.poolingStructure.pools !== null && data.notionalPooling.poolingStructure.pools.length > 0 ?
                      data.notionalPooling.poolingStructure.pools.map(pool => {
                        if (pool.id === item.id) {
                          return <dl><dt>{pool.poolCurrency.name} {'Pool - '} {translations(poolingStructurePageJson.subPoolSingleCurrency)} {pool.poolCurrency.name} {pool.accounts.length} {translations(poolingStructurePageJson.accounts)}</dt><dd>&nbsp;</dd></dl>
                        }
                      }) : ''
                  }
                  <div className="detail-section__content__heading">{translations(pageJson.coveredCreditBoxLabel)}</div>
                  <dl className="detail-section__content__list">
                    <dt>{translateWordForOption(pageJson.coveredCreditSubLabels)[0]}</dt>
                    {
                      item.coveredCreditBalance !== undefined && 'baseRate' in item.coveredCreditBalance
                        ? <dd>{item.coveredCreditBalance.baseRate}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.coveredCreditSubLabels)[1]}</dt>
                    {
                      item.coveredCreditBalance !== undefined && 'baseRateCode' in item.coveredCreditBalance
                        ? <dd>{item.coveredCreditBalance.baseRateCode}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.coveredCreditSubLabels)[2]}</dt>
                    {
                      item.coveredCreditBalance !== undefined && 'spread' in item.coveredCreditBalance
                        ? <dd>{item.coveredCreditBalance.spread}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>&nbsp;</dt>
                    <dd>
                      {
                        item.coveredCreditBalance !== undefined
                          ? item.coveredCreditBalance.rate === "true"
                            ? translateWordForOption(pageJson.coveredCreditSubLabels)[3]
                            : translateWordForOption(pageJson.coveredCreditSubLabels)[4]
                          : ''
                      }
                    </dd>
                    <dt>{translateWordForOption(pageJson.coveredCreditSubLabels)[5]}</dt>
                    {
                      item.coveredCreditBalance !== undefined && 'minimumInterest' in item.coveredCreditBalance
                        ? <dd>{item.coveredCreditBalance.minimumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.coveredCreditSubLabels)[6]}</dt>
                    {
                      item.coveredCreditBalance !== undefined && 'maximumInterest' in item.coveredCreditBalance
                        ? <dd>{item.coveredCreditBalance.maximumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                  </dl>
                  <div className="detail-section__content__heading">{translations(pageJson.coveredDebitBoxLabel)}</div>
                  <dl className="detail-section__content__list">
                    <dt>{translateWordForOption(pageJson.coveredDebitSubLabels)[0]}</dt>
                    {
                      item.coveredDebitBalance !== undefined && 'baseRate' in item.coveredDebitBalance
                        ? <dd>{item.coveredDebitBalance.baseRate}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.coveredDebitSubLabels)[1]}</dt>
                    {
                      item.coveredDebitBalance !== undefined && 'baseRateCode' in item.coveredDebitBalance
                        ? <dd>{item.coveredDebitBalance.baseRateCode}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.coveredDebitSubLabels)[2]}</dt>
                    {
                      item.coveredDebitBalance !== undefined && 'spread' in item.coveredDebitBalance
                        ? <dd>{item.coveredDebitBalance.spread}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>&nbsp;</dt>
                    <dd>
                      {
                        item.coveredDebitBalance !== undefined
                          ? item.coveredDebitBalance.rate === "true"
                            ? translateWordForOption(pageJson.coveredDebitSubLabels)[3]
                            : translateWordForOption(pageJson.coveredDebitSubLabels)[4]
                          : ''
                      }
                    </dd>
                    <dt>{translateWordForOption(pageJson.coveredDebitSubLabels)[5]}</dt>
                    {
                      item.coveredDebitBalance !== undefined && 'minimumInterest' in item.coveredDebitBalance
                        ? <dd>{item.coveredDebitBalance.minimumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.coveredDebitSubLabels)[6]}</dt>
                    {
                      item.coveredDebitBalance !== undefined && 'maximumInterest' in item.coveredDebitBalance
                        ? <dd>{item.coveredDebitBalance.maximumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                  </dl>
                  <div className="detail-section__content__heading">{translations(pageJson.ResidualCreditBoxLabel)}</div>
                  <dl className="detail-section__content__list">
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[0]}</dt>
                    {
                      item.residualCreditBalance !== undefined && 'baseRate' in item.residualCreditBalance
                        ? <dd>{item.residualCreditBalance.baseRate}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[1]}</dt>
                    {
                      item.residualCreditBalance !== undefined && 'baseRateCode' in item.residualCreditBalance
                        ? <dd>{item.residualCreditBalance.baseRateCode}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[2]}</dt>
                    {
                      item.residualCreditBalance !== undefined && 'spread' in item.residualCreditBalance
                        ? <dd>{item.residualCreditBalance.spread}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>&nbsp;</dt>
                    <dd>
                      {
                        item.residualCreditBalance !== undefined
                          ? item.residualCreditBalance.rate === "true"
                            ? translateWordForOption(pageJson.ResidualCreditSubLabels)[3]
                            : translateWordForOption(pageJson.ResidualCreditSubLabels)[4]
                          : ''
                      }
                    </dd>
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[5]}</dt>
                    {
                      item.residualCreditBalance !== undefined && 'minimumInterest' in item.residualCreditBalance
                        ? <dd>{item.residualCreditBalance.minimumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[6]}</dt>
                    {
                      item.residualCreditBalance !== undefined && 'maximumInterest' in item.residualCreditBalance
                        ? <dd>{item.residualCreditBalance.maximumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                  </dl>

                  <div className="detail-section__content__heading">{translations(pageJson.ResidualDebitBoxLabel)}</div>
                  <dl className="detail-section__content__list">
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[0]}</dt>
                    {
                      item.residualDebitBalance !== undefined && 'baseRate' in item.residualDebitBalance
                        ? <dd>{item.residualDebitBalance.baseRate}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[1]}</dt>
                    {
                      item.residualDebitBalance !== undefined && 'baseRateCode' in item.residualDebitBalance
                        ? <dd>{item.residualDebitBalance.baseRateCode}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[2]}</dt>
                    {
                      item.residualDebitBalance !== undefined && 'spread' in item.residualDebitBalance
                        ? <dd>{item.residualDebitBalance.spread}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>&nbsp;</dt>
                    <dd>
                      {
                        item.residualDebitBalance !== undefined
                          ? item.residualDebitBalance.rate === "true"
                            ? translateWordForOption(pageJson.ResidualCreditSubLabels)[3]
                            : translateWordForOption(pageJson.ResidualCreditSubLabels)[4]
                          : ''
                      }
                    </dd>
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[5]}</dt>
                    {
                      item.residualDebitBalance !== undefined && 'minimumInterest' in item.residualDebitBalance
                        ? <dd>{item.residualDebitBalance.minimumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[6]}</dt>
                    {
                      item.residualDebitBalance !== undefined && 'maximumInterest' in item.residualDebitBalance
                        ? <dd>{item.residualDebitBalance.maximumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                  </dl>

                  <dl className="detail-section__content__list">
                    <dt>{translations(pageJson.grpLimit)}</dt>
                    <dd>{item.odLimit !== undefined ? item.odLimit : ''}</dd>
                    <dt>{translations(pageJson.unauthorizedInterestType)}</dt>
                    <dd>
                      {
                        item.unauthorizedInterestType !== undefined
                          ? item.unauthorizedInterestType === true
                            ? translations(pageJson.floating)
                            : translations(pageJson.fixed)
                          : ''
                      }
                    </dd>
                  </dl>

                  <div className="detail-section__content__heading">{translations(pageJson.unauthorisedOd)}</div>
                  <dl className="detail-section__content__list">
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[0]}</dt>
                    {
                      item.unAuthorisedOD !== undefined && 'baseRate' in item.unAuthorisedOD
                        ? <dd>{item.unAuthorisedOD.baseRate}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[1]}</dt>
                    {
                      item.unAuthorisedOD !== undefined && 'baseRateCode' in item.unAuthorisedOD
                        ? <dd>{item.unAuthorisedOD.baseRateCode}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[2]}</dt>
                    {
                      item.unAuthorisedOD !== undefined && 'spread' in item.unAuthorisedOD
                        ? <dd>{item.unAuthorisedOD.spread}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>&nbsp;</dt>
                    <dd>
                      {
                        item.unAuthorisedOD !== undefined
                          ? item.unAuthorisedOD.rate === "true"
                            ? translations(pageJson.margin)
                            : translations(pageJson.fixedValue)
                          : ''
                      }
                    </dd>
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[5]}</dt>
                    {
                      item.unAuthorisedOD !== undefined && 'maximumInterest' in item.unAuthorisedOD
                        ? <dd>{item.unAuthorisedOD.maximumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                    <dt>{translateWordForOption(pageJson.ResidualCreditSubLabels)[6]}</dt>
                    {
                      item.unAuthorisedOD !== undefined && 'minimumInterest' in item.unAuthorisedOD
                        ? <dd>{item.unAuthorisedOD.minimumInterest}</dd>
                        : <dd>&nbsp;</dd>
                    }
                  </dl>
                </div>
              ]
            })
            : ''}
      </div>
    </div>
  </div>
)

export default Interestoptimisation



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/NPPreview/interestOptimisation.js